import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

const OfflineBanner = () => {
    const [isOffline, setIsOffline] = useState(!navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOffline(false);
        const handleOffline = () => setIsOffline(true);

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);

    if (!isOffline) return null;

    return (
        <div className="bg-destructive text-destructive-foreground text-xs font-medium py-1.5 px-4 flex items-center justify-center gap-2 animate-in slide-in-from-top-[5px] duration-300 z-50 fixed top-0 left-0 right-0 max-w-md mx-auto">
            <WifiOff size={16} strokeWidth={2} /> You are offline. Reconnecting...
        </div>
    );
};

export default OfflineBanner;
